export default __webpack_public_path__ + "static/media/EFS.0164e173.png";